import React from 'react';
import './FooterStyle.css';
import { FaMailBulk, FaWaze, FaWhatsapp } from "react-icons/fa";
import logo from "../assets/logoHSHA.png"; // ודאי שהנתיב נכון

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container three-cols">

        {/* לוגו - ימין */}
        <div className="footer-logo-box">
          <img src={logo} alt="לוגו החברה" className="footer-logo" />
        </div>

        {/* טקסט עלינו - אמצע */}
        <div className="footer-about">
          <h4>עלינו</h4>
          <p>
            לחברתנו פטנט יחודי ובלעדי של מגופי מים נשלטים מרחוק.<br />
            - מיפוי אינטראקטיבי של תשתיות מים עירוניות ושליטה על המגופים.<br />
            - פתיחה וסגירת מגוף בשליטה מרחוק ממרכז שליטה או מהנייד.<br /><br />
            לחברתנו נסיון עשיר בהקמת ותפעול תשתיות מים עירוניות חכמות.
          </p>
        </div>

        {/* פרטי קשר - שמאל */}
        <div className="footer-left">
          <div className="footer-item">
            <FaWaze size={20} style={{ color: "#fff", marginRight: "1rem" }} />
            <p>
              <a href="https://www.google.com/maps?q=אלי הורוביץ+19,+רחובות,+ישראל" >
                אלי הורוביץ 19, רחובות, ישראל
              </a>
            </p>

            {/*<p>אלי הורוביץ 19, רחובות</p>*/}
          </div>
          <div className="footer-item">
            <FaWhatsapp size={20} style={{ color: "#fff", marginRight: "1rem" }} />
            <a href="https://wa.me/972525949642" target="_blank" rel="noopener noreferrer" className="whatsapp-link">
               525949642 972+
            </a>
          </div>
          <div className="footer-item">
            <FaMailBulk size={20} style={{ color: "#fff", marginRight: "1rem" }} />
            <p>hsha.ldt@gmail.com</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Footer;
